module.exports = __webpack_public_path__ + "src/assets/img/usermodel.1d891ead.jpg";